import React from "react";
import styled from "styled-components";
import { FiArrowDown, FiArrowUp } from "react-icons/fi";
import { FaSort } from "react-icons/fa";
import { colors } from "./colors";

export default function SortableHeader({ label, sortKey, sort, onSort, align = "left", ...cell }) {
    const active = sort.key === sortKey;
    const Icon = !active ? FaSort : sort.dir === "desc" ? FiArrowDown : FiArrowUp;
    return (
        <th scope="col" aria-sort={active ? (sort.dir === "desc" ? "descending" : "ascending") : "none"} {...cell}>
            <Button type="button" onClick={() => onSort(sortKey)} $active={active} $right={align === "right"}>
                {label}
                <Icon aria-hidden />
            </Button>
        </th>
    );
}

const Button = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    flex-direction: ${({ $right }) => ($right ? "row-reverse" : "row")};
    border: none;
    background: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    color: ${({ $active }) => ($active ? colors.ink : "inherit")};
    svg { font-size: 11px; color: ${({ $active }) => ($active ? colors.ink : colors.subtle)}; }
    &:hover { color: ${colors.ink}; }
`;
